import store from '@/store';
export default {
  height: "auto",
  calcHeight: 30,
  tip: false,
  searchShow: true,
  searchSpan: 5,
  searchMenuSpan: 4,
  searchLabelWidth: 120,
  border: true,
  index: true,
  viewBtn: false,
  editBtn: false,
  delBtn: false,
  addBtn: false,
  selection: false,
  dialogClickModal: false,
  column: [
    {
      label: "主键id",
      prop: "id",
      type: "input",
      addDisplay: false,
      editDisplay: false,
      viewDisplay: false,
      hide: true,
    },
    {
      label: "进件编号",
      prop: "businessCode",
      type: "input",
      search: true,
      searchOrder: 333,
    },
    {
      label: "所属代理商",
      prop: "businessDeptName",
      type: "input",
    },
    {
      label: "产品类型",
      prop: "rentType",
      dicData: store.getters.porductTypes
    },
    {
      label: "产品类型",
      prop: "rentTypeList",
      type: "select",
      search: true,
      searchMultiple: true,
      hide: true,
      showColumn: false,
      dicData: store.getters.porductTypes,
      searchOrder: 888,
    },
    {
      label: "租赁人",
      prop: "name",
      type: "input",
      search: "true",
      searchOrder: 777,
    },
    {
      label: "手机号",
      prop: "phoneNumber",
      type: "input",
    },
    {
      label: "代偿金额",
      prop: "hadCompensationFundAmount",
      type: "input",
    },
    {
      label: "代偿日期",
      prop: "repaymentDate",
      type: "daterange",
      valueFormat: 'yyyy-MM-dd',
      search: true,
      searchOrder: 444,
      searchRange: true,
    },
    {
      label: "代偿期数",
      prop: "currentTenancy",
      type: "input",
      formatter: (val, value, label) => {
        return value ? value + "/" + val["tenancy"] : "-";
      },
    },
    {
      label: "代偿状态",
      prop: "compensationFundStatus",
      type: "select",
      search: true,
      searchOrder: 666,
      dicData: [
        {
          label: "已代偿",
          value: 1,
        },
        {
          label: "转客户还租",
          value: 2,
        },
        {
          label: "已退代偿款",
          value: 3,
        },
      ],
    },
    {
      label: "客户是否还租",
      prop: "customerRepayment",
      type: "select",
      search: true,
      searchOrder: 555,
      dicData: [
        {
          label: "是",
          value: true,
        },
        {
          label: "否",
          value: false,
        },
      ],
    },
    {
      label: "所属代理商",
      prop: "businessDeptIdList",
      type: "select",
      filterable: true,
      addDisplay: false,
      editDisplay: false,
      viewDisplay: false,
      search: true,
      searchMultiple: true,
      searchClearable: true,
      defaultExpandAll: true,
      searchOrder: 1000,
      hide: true,
      dicData: [],
      props: {
        label: "title",
        value: "id",
      },
    },

  ],
};
